import type { FeatureGroup } from '../../../types';
import { CRM_FEATURE_GROUP } from '../group';

export const CRM_EVENTS_FEATURE_GROUP: FeatureGroup = {
  guid: 'c7d2e5b8-1a43-4c69-8b27-6e9f1d2a05ff',
  name: 'crm_events',
  description: 'The CRM events page',
  product: 'crm',
  parentGuid: CRM_FEATURE_GROUP.guid,
};
